<div class="feedback-dialog__header">
    <h1 class="mat-dialog-title">Lad os høre fra dig</h1>
    <button
        class="feedback-dialog__close-button"
        color="basic"
        mat-dialog-close
        mat-icon-button
        tabindex="0"
        type="button"
        aria-label="Luk feedback dialog"
    >
        <mat-icon svgIcon="close"></mat-icon>
    </button>
</div>

<mat-dialog-content>
    <form class="feedback-dialog__form" [formGroup]="feedbackForm">
        <mat-form-field class="feedback-dialog__form-field" appearance="fill">
            <mat-label>Type</mat-label>
            <mat-select formControlName="type">
                @for (type of feedbackTypes; track type.value) {
                    <mat-option [value]="type.value">
                        {{ type.label }}
                    </mat-option>
                }
            </mat-select>
            @if (feedbackForm.get("type")?.hasError("required")) {
                <mat-error> Vælg en type </mat-error>
            }
        </mat-form-field>

        <mat-form-field class="feedback-dialog__form-field" appearance="fill">
            <mat-label>Område</mat-label>
            <input formControlName="area" matInput />
            <mat-hint>f.eks. Min Side eller Oversigtskort</mat-hint>
            @if (feedbackForm.get("area")?.hasError("required")) {
                <mat-error> Område er påkrævet </mat-error>
            }
        </mat-form-field>

        @if (requiresEmailInput) {
            <mat-form-field class="feedback-dialog__form-field" appearance="fill">
                <mat-label>Din e-mail</mat-label>
                <input autocomplete="email" formControlName="email" matInput type="email" />
                <mat-hint>Vi mangler din e-mail for at kunne følge op</mat-hint>
                @if (feedbackForm.get("email")?.hasError("required")) {
                    <mat-error> E-mail er påkrævet </mat-error>
                }
                @if (feedbackForm.get("email")?.hasError("email")) {
                    <mat-error> Indtast en gyldig e-mail </mat-error>
                }
            </mat-form-field>
        }

        <mat-form-field class="feedback-dialog__form-field" appearance="fill">
            <mat-label>Besked</mat-label>
            <textarea formControlName="message" matInput rows="5"></textarea>
            @if (feedbackForm.get("message")?.hasError("required")) {
                <mat-error> Besked er påkrævet </mat-error>
            }
            @if (feedbackForm.get("message")?.hasError("minlength")) {
                <mat-error> Minimum 10 tegn </mat-error>
            }
        </mat-form-field>

        <div class="feedback-dialog__screenshot-section">
            <button
                class="feedback-dialog__screenshot-button"
                [disabled]="isCapturingScreenshot || screenshotBlob"
                mat-stroked-button
                type="button"
                aria-label="Tag skærmbillede"
                (click)="captureScreenshot()"
            >
                <mat-icon svgIcon="camera"></mat-icon>
                {{ isCapturingScreenshot ? "Tager et billede..." : "Vedhæft skærmbillede" }}
            </button>
            <mat-hint align="end">Vedhæft et billede af din nuværende skærm</mat-hint>
            @if (screenshotBlob) {
                <div class="feedback-dialog__screenshot-status">
                    <span class="feedback-dialog__screenshot-ready">✓ Skærmbillede er klar</span>

                    <button
                        class="feedback-dialog__screenshot-clear"
                        mat-icon-button
                        type="button"
                        aria-label="Fjern skærmbillede"
                        (click)="clearScreenshot()"
                    >
                        <mat-icon>close</mat-icon>
                    </button>
                </div>
            }
        </div>

        <div class="feedback-dialog__data-consent">
            <div class="feedback-dialog__consent-header">
                <mat-checkbox class="feedback-dialog__consent-checkbox" formControlName="agreeToShare">
                    <span class="feedback-dialog__consent-text">
                        Jeg accepterer at følgende informationer bliver delt
                    </span>
                </mat-checkbox>
                <button
                    class="feedback-dialog__data-toggle"
                    mat-icon-button
                    type="button"
                    [attr.aria-expanded]="isDataListExpanded"
                    aria-label="Vis/skjul datadetaljer"
                    (click)="toggleDataList()"
                >
                    <mat-icon
                        [class.feedback-dialog__data-toggle--expanded]="isDataListExpanded"
                        svgIcon="chevron-down"
                    ></mat-icon>
                </button>
            </div>
            @if (isDataListExpanded) {
                <ul class="feedback-dialog__data-list">
                    <li class="feedback-dialog__data-list-item">Feedback type og område</li>
                    <li class="feedback-dialog__data-list-item">Min besked</li>
                    <li class="feedback-dialog__data-list-item">Mit navn/brugernavn</li>
                    @if (requiresEmailInput) {
                        <li class="feedback-dialog__data-list-item">Min e-mailadresse</li>
                    }
                    <li class="feedback-dialog__data-list-item">Værks navn</li>
                    <li class="feedback-dialog__data-list-item">Min enhedstype og version</li>
                    <li class="feedback-dialog__data-list-item">Tidsstempel for henvendelse</li>
                </ul>
            }
            @if (feedbackForm.get("agreeToShare")?.hasError("required") && feedbackForm.get("agreeToShare")?.touched) {
                <div class="feedback-dialog__consent-error">Du skal acceptere datadelinger for at fortsætte</div>
            }
        </div>
    </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
    @if (submitError) {
        <div class="feedback-dialog__submit-error" role="alert">{{ submitError }}</div>
    }
    <button [disabled]="isSending" mat-button type="button" aria-label="Luk feedback dialog" (click)="onClose()">
        Annuller
    </button>
    <button
        color="primary"
        [disabled]="!feedbackForm.valid || isSending"
        mat-raised-button
        type="button"
        aria-label="Send feedback"
        (click)="onSubmit()"
    >
        {{ isSending ? "Sender..." : "SEND" }}
    </button>
</mat-dialog-actions>
